import React from "react";
import OButton from "components/reusable/OButton";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  isDanger = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div
            className="absolute inset-0 bg-gray-500 opacity-75"
            onClick={onClose}
          ></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {title}
            </h3>
            <p className="mt-2 text-sm text-gray-500">{message}</p>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <OButton
              onClick={onConfirm}
              label={confirmText}
              isLoading={isLoading}
              extraClasses={`ml-3 ${
                isDanger
                  ? "bg-red-600 hover:bg-red-700"
                  : "bg-LightBlue hover:bg-DarkBlue"
              }`}
            />
            <OButton
              onClick={onClose}
              label={cancelText}
              variant="outline"
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
